const getTools = (rootState) => rootState.ui.customTools.registeredTools;

export default getTools;
